import { Component, ElementRef, Inject, Input, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { FormField } from '../../../../../../../sellions_forms/projects/forms/src/lib/interfaces/form-field.interface';
import { ProcessVariables } from '../../interfaces/process-variables.interface';
import { SellionsFormsRendererComponent } from '../../../../../../../sellions_forms/projects/forms/src/lib/components/renderer/renderer.component';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material';
import { MultipartFile } from '../../../../../../../sellions_forms/projects/forms/src/lib/components/controls/multipart-files/multipart-file';
import { CloseDialogComponent } from './close-dialog/close-dialog.component';

@Component({
  selector: 'form-viewer',
  templateUrl: './form-viewer.component.html',
  encapsulation: ViewEncapsulation.None,
})
export class FormViewerComponent implements OnInit {
  @Input() form: FormField[];
  @Input() processKey: string;
  @Input() formName: string;
  @Input() sendButtonText: string;
  @Input() processError: any;
  @Input() dataViewBaseAPI: string;
  @Input() answers: any;
  @Input() sendDelegate: (values: ProcessVariables, callback: () => void) => void;
  @ViewChild(SellionsFormsRendererComponent) sellionsFormsRendererComponent: SellionsFormsRendererComponent;
  @ViewChild('content') formViewerContent: ElementRef;
  private formData: { [key: string]: any } = {};
  public isSendButtonDisabled = false;

  constructor(private dialog: MatDialog, private dialogRef: MatDialogRef<FormViewerComponent>, @Inject(MAT_DIALOG_DATA) public data: any) {}

  ngOnInit() {
    if (this.data) {
      this.form = this.data.form;
      this.processKey = this.data.processKey;
      this.formName = this.data.formName;
      this.processError = this.data.processError;
      this.dataViewBaseAPI = this.data.dataViewBaseAPI;
      this.sendDelegate = this.data.sendDelegate;
      this.sendButtonText = this.data.sendButtonText || 'Zapisz';
      if (this.data.answers) {
        this.answers = this.getAnswers(this.data.answers);
      }
    }
  }

  public send() {
    if (!this.isFormValid() || this.isSendButtonDisabled) {
      this.formViewerContent.nativeElement.scrollTo(0, 0);
      this.processError = { value: this.data.formInvalidText || 'Formularz wypełniony niepoprawnie' };
      return;
    }

    this.isSendButtonDisabled = true;

    const formDataWithReferences = this.formData;

    const result: ProcessVariables = { variables: [], multipartFiles: [] };
    for (const key in formDataWithReferences) {
      const value = formDataWithReferences[key];
      if (Array.isArray(value) && value.length > 0 && value[0] instanceof MultipartFile) {
        this.handleMultipartFiles(result, key, value);
      } else {
        result.variables.push({ name: key, value });
      }
    }
    this.sendDelegate(result, () => {
      this.isSendButtonDisabled = false;
    });
  }

  private handleMultipartFiles(result: ProcessVariables, variableName: string, multipartFiles: Array<MultipartFile>): void {
    const fileNameArray: Array<string> = [];
    multipartFiles.forEach((part) => {
      if (part instanceof MultipartFile) {
        result.multipartFiles.push(part);
        fileNameArray.push(part.fileNameWithPath);
      } else {
        throw new Error('The array contains a type other than File');
      }
    });
    result.variables.push({ name: variableName, value: fileNameArray });
  }

  public formChangeUpdate(data: FormGroup) {
    this.formData = data.getRawValue();
  }

  public isFormValid(): boolean {
    return this.sellionsFormsRendererComponent.isFormValid();
  }

  public confirmClosing() {
    const hasChanges = this.sellionsFormsRendererComponent.hasChanges();
    if (hasChanges) {
      this.dialog.open(CloseDialogComponent, { panelClass: 'form-viewer-close-dialog', disableClose: true });
    } else {
      this.dialog.closeAll();
    }
  }

  getAnswers(data: any) {
    const answers = {};
    this.form.forEach((formControl) => {
      const paramName = formControl.id;
      if (data[paramName]) {
        answers[paramName] = data[paramName];
      }
    });
    return answers;
  }

  clearError(): void {
    this.processError = {};
  }
}



// WEBPACK FOOTER //
// ./src/submodules/sellions_layout_renderer/projects/sellions-layout-renderer-lib/src/lib/components/form-viewer/form-viewer.component.ts